export enum WhitelistActionType {
  CREATE_MULTIPLE_WHITELIST_FAILURE = '@@whitelist/CREATE_MULTIPLE_WHITELIST_FAILURE_CLIENT',

  CREATE_MULTIPLE_WHITELIST_REQUEST = '@@whitelist/CREATE_MULTIPLE_WHITELIST_REQUEST',
  CREATE_MULTIPLE_WHITELIST_SUCCESS = '@@whitelist/CREATE_MULTIPLE_WHITELIST_SUCCESS',
  CREATE_WHITELIST_FAILURE = '@@whitelist/CREATE_WHITELIST_FAILURE_CLIENT',

  CREATE_WHITELIST_REQUEST = '@@whitelist/CREATE_WHITELIST_REQUEST',
  CREATE_WHITELIST_SUCCESS = '@@whitelist/CREATE_WHITELIST_SUCCESS',
  DELETE_WHITELIST_FAILURE = '@@whitelist/DELETE_WHITELIST_FAILURE',

  DELETE_WHITELIST_REQUEST = '@@whitelist/DELETE_WHITELIST_REQUEST',
  DELETE_WHITELIST_SUCCESS = '@@whitelist/DELETE_WHITELIST_SUCCESS',
  GET_ALL_WHITELIST_FAILURE = '@@whitelist/GET_ALL_WHITELIST_FAILURE',

  GET_ALL_WHITELIST_REQUEST = '@@whitelist/GET_ALL_WHITELIST_REQUEST',
  GET_ALL_WHITELIST_SUCCESS = '@@whitelist/GET_ALL_WHITELIST_SUCCESS',
  TOGGLE_CREATE = '@@whitelist/TOGGLE_CREATE',
}
